import React, { Component } from 'react';
export default class ReviewerTypeKeys extends Component {
  render() {
    const { reviewerTypes, userColour, reviewerColour } = this.props;
    return (
      <div className='w-20'>
        {reviewerTypes.map((type, typeIndex) => {
          return (
            <p key={type + typeIndex} style={{ color: type === 'Self' ? userColour : reviewerColour }}>
              {type !== 'space' ? (
                <strong>{type}</strong>
              ) : (
                <strong>&nbsp;</strong>
              )}
            </p>
          )
        })}
      </div>
    );
  }
}
